import React from 'react';
import { DialogProps } from '../DialogProvider';

// 비공개/ 공개 성공 알럿 팝업
// openTp 넘겨받아서 Y/N (A/N) 구분하여 h3태그에 비공개/공개 보여줄 것.
interface PrivateSuccessDialog extends DialogProps {
	type: '';
}

const PrivateSuccessDialog = ({ ...props }: PrivateSuccessDialog) => {
	const handleClose = () => {
		props.onClose?.();
		window.location.reload();

	};
	return (
		<div className="comm_popup" style={{ display: 'block' }}>
			<div className="comm_popup_wrap pa30">
				<div className="comm_popup_title">
					<h3>비공개/공개 </h3>
				</div>
				<div className="comm_popup_content mt10">
					<p className="explain">성공하였습니다.</p>
				</div>
				<div className="comm_popup_btn mt25">
					<button type="button" className="btn_check one" onClick={handleClose}>
						확인
					</button>
				</div>
			</div>
		</div>
	);
};

export default PrivateSuccessDialog;
